import SentimentIcon from "components-for/sentiment/sentiment-icon";
import { TableMenuItem } from "@edgetier/client-components";
import { FunctionComponent, memo } from "react";
import { IProps } from "./interactions-table-sentiment-column-menu-item.types";
import "./interactions-table-sentiment-column-menu-item.scss";

/**
 * Show a sentiment property that can be clicked to filter an interactions table.
 * @param props.children       Content of the item.
 * @param props.isActiveFilter Whether the data is being filtered by this property or not.
 * @param props.onClick        Handle clicking a sentiment.
 * @param props.sentiment      The sentiment being displayed.
 * @returns                    Icon and label.
 */
const InteractionsTableSentimentColumnMenuItem: FunctionComponent<IProps> = ({
    children,
    isActiveFilter,
    onClick,
    sentiment,
}) => {
    return (
        <TableMenuItem
            className="interactions-table-sentiment-column__menu-item grid__menu-item"
            isActive={isActiveFilter}
            onClick={() => onClick(sentiment)}
        >
            <SentimentIcon fixedWidth sentiment={sentiment} />
            {children}
        </TableMenuItem>
    );
};

export default memo(InteractionsTableSentimentColumnMenuItem);
